import request from '@/utils/request';

// 事业部管理-列表
export async function fetchDivisionList(data) {
  return request('/api/division/list', {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}

// 事业部管理-选项列表
export async function fetchDivisionOptions(data) {
  return request('/api/division/options', {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}

// 事业部管理-创建
export async function createDivision(data) {
  return request('/api/division/create', {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}

// 事业部管理-更新
export async function updateDivision(data) {
  return request('/api/division/update', {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}

// 事业部管理-删除
export async function deleteDivision(data) {
  return request('/api/division/delete', {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}

// 事业部管理-删除关联
export async function deleteDivisionRelation(data) {
  return request('/api/division/del-relation', {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}

// 事业部管理-添加关联
export async function addDivisionRelation(data) {
  return request('/api/division/add-relation', {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}
